export default __webpack_public_path__ + "static/media/Shared-Image-ARTIGOS-SYS-01.137183e3.png";